import { Component, inject, Input, OnInit } from '@angular/core';
import { AudioService } from '../../../services/audio.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { AccountComponent } from '../../account/account.component';
import { AuthService } from '../../../services/auth/auth.service';
import { SupaStatisticsRepository } from '../../../data/supa-statistics/supa-statistics.repository';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss']
})
export class HeaderNavComponent implements OnInit {
  auth = inject(AuthService);
  statisticsRepository = inject(SupaStatisticsRepository);

  isDev = !environment.production;

  @Input() defaultHref: string | undefined;

  constructor(private modalController: ModalController,
              private popoverController: PopoverController,
              public audio: AudioService) {
  }

  ngOnInit() {
  }

  showAccountModal() {
    this.modalController.create({component: AccountComponent})
      .then(modal => modal.present());
  }

  showAccountPopover(ev: Event) {
    this.popoverController.create({
      component: AccountComponent,
      event: ev
    })
      .then(modal => modal.present());
  }
}
